import React from "react";
import { View, StyleSheet } from "react-native";
import { Dropdown } from "react-native-element-dropdown";
import { fonts } from "../styles/theme";
import AppText from "./AppText";

interface CommonDropdownProps {
  title?: string;
  isRequired?: boolean;
  data: Array<{ title: string; value: string | number }>;
  value: string | number | null;
  onChange: (item: any) => void;
  placeholder: string;
  labelField?: string;
  valueField?: string;
  isEditable?: boolean;
  error?: string;
  testID?: string
}

const CommonDropdown: React.FC<CommonDropdownProps> = ({
  title,
  isRequired = false,
  data,
  value,
  onChange,
  placeholder,
  labelField = "title",
  valueField = "value",
  isEditable = true,
  error = null,
  testID
}) => {
  return (
    <View>
      {title && (
        <AppText style={styles.label} testID={`${testID}-label`}>
          {title} {isRequired && <AppText style={styles.requiredAsterisk}>*</AppText>}
        </AppText>
      )}
      <View style={{ marginBottom: 10 }}>
        <Dropdown
          testID={testID}
          data={data}
          value={value}
          onChange={onChange}
          labelField={labelField}
          valueField={valueField}
          placeholder={placeholder}
          mode="auto"
          disable={!isEditable}
          style={[
            styles.dropdown,
            !isEditable && styles.disabledDropdown,
            error ? styles.errorBorder : null,
          ]}
          placeholderStyle={styles.placeholderText}
          selectedTextStyle={styles.selectedText}
          itemTextStyle={styles.itemText}
          itemContainerStyle={styles.dropdownItemContainer}
        />
        {error && <AppText style={styles.errorText} testID={`${testID}-error`}>{error}</AppText>}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    marginBottom: 8,
    fontSize: 12,
    color: "#979797",
    //fontWeight: "600",
    fontFamily: fonts.regular},
  requiredAsterisk: {
    color: "black"},
  dropdown: {
    height: 45,
    borderWidth: 1,
    borderRadius: 15,
    paddingHorizontal: 12,
    fontSize: 14,
    color: "#343434",
    //fontWeight: "500",

    borderColor: "#CBCBCB",
    fontFamily: fonts.regular},
  placeholderText: {
    fontSize: 14,
    color: "#979797",
    //fontWeight: "500",
    fontFamily: fonts.regular},
  selectedText: {
    fontSize: 14,
    color: "#343434",
    //fontWeight: "600",
    fontFamily: fonts.regular},
  itemText: {
    color: "#333",
    fontFamily: fonts.regular},
  dropdownItemContainer: {
    borderBottomWidth: 1,
    borderColor: "#ccc"},
  disabledDropdown: {
    backgroundColor: "#f5f5f5",
    borderColor: "#ddd"},
  errorBorder: {
    borderColor: "red"},
  errorText: {
    color: "red",
    fontSize: 12,
    marginTop: 4}});

export default CommonDropdown;
